import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';

type Region = 'ca' | 'ca-on';

/**
 * Get Terms & Conditions URL based on user's region
 */
const getTermsUrl = (region: Region): string => {
  return `#${region}`;
};

const AppFooter: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Get region from user context, default to 'ca'
  const region: Region = (user?.location as Region) || 'ca';
  const termsUrl = getTermsUrl(region);

  return (
    <footer className="px-4 py-3 bg-surface border-t border-border/30 text-center">
      {/* Terms and Conditions link hidden */}
      {/* <a
        href={termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-muted-foreground hover:text-primary transition-colors"
      >
        {t('footer.termsAndConditions')}
      </a> */}
    </footer>
  );
};

export default AppFooter;
